
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reward",
      function () {
        return require("private-next-pages/reward/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reward"])
      });
    }
  